import { CDN_HOST } from '@/globals';

export function pathToURL(path: string): string {
    // if (path?.startsWith('/')) return path; // To allow local paths to work in storybook
    return path && CDN_HOST + path;
}
